<template>
  <div class="search-camera" :style="{paddingLeft: split+'px'}" :class="{active: active}" ref="layout">
    <router-link :to="item.to" tag="a" :style="{maxWidth:language==='en'?'140px':'140px',transitionDelay: i*30+'ms'}" class="camera" v-for="(item,i) in arr" :key="i" >
      <vcenter>
        <i class="iconfont" :class="item.icon"></i>
        <div style="margin-top:10px;" v-html="item.name"></div>
        <img v-if="item.new" class="icon-new" :src="`${$cdn}images/pro-new.png`" >
      </vcenter>
    </router-link>
  </div>
</template>

<script>
import vcenter from '@/components/vcenter'
import {mapState} from 'vuex'

export default {
  props: {
    'split': {
      default: 0
    },
    'origin': {
      default: ''
    }
  },
  computed: {
    ...mapState({
      langNavs: state => state.language.home.navs,
      language: state => state.language.current
    })
  },
  data () {
    return {
      active: false,
      arr: undefined
    }
  },
  components: {
    vcenter
  },
  watch: {
    origin: {
      handler (newVal, oldVal) {
        if (oldVal) {
          this.active = false
          setTimeout(() => {
            this.showNav()
          }, 50 * this.langNavs.setting[oldVal].length)
        } else {
          this.active = false
          this.showNav()
        }
      },
      immediate: true
    }
  },
  methods: {
    showNav () {
      this.arr = this.langNavs.setting[this.origin]
      setTimeout(() => {
        this.active = true
      }, 200)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
$lHeight: 145px;

.search-camera {
  background-color: #fff;
  height: $lHeight;
  border-bottom: 1px solid #e5e5e5;
  display: flex;

  .camera {
    display: block;
    max-width: 140px;
    flex: 1;
    padding: 0 24px;
    line-height: 1;
    text-align: center;
    font-size: 14px;
    color: #b6b6b6;
    cursor: pointer;
    height: 100%;
    transition: all .1s cubic-bezier(.77, 0, .175, 1);
    transform: translateX(100px);
    opacity: 0;

    .icon-new{
      position: absolute;
      top: 14px;
      right: 14px;
    }
    &:hover {
      color: #000;
    }

    i {
      font-size: 60px;
    }
  }

  &.active {
    .camera {
      opacity: 1;
      transform: translateX(0)
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/navs/temp.vue